export const initialExtensions = {
  active: true,
  method: "GET",
  url: "",
  timeout: 0,
  auth: {
    type: "no_authentication",
    username: null,
    password: null,
    token: null,
    url: null,
    access_key: null,
    access_key_input: null,
    header_key: "",
    prefix: null,
    method: null,
    payload: "{}",
    headers: [],
  },
  body: {
    type: "application/json",
    payload: "{}",
  },
  prompt: "",
  headers: [],
  variables: [],
  variables_desk: [],
};
